var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vueMain", { attrs: { title: _vm.$t("design.title") } }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("nav", { staticClass: "col-lg-2 pl-0 pr-0 sidebar hover-bg" }, [
            _c("ul", { staticClass: "nav-pills nav flex-column" }, [
              _c(
                "li",
                {
                  staticClass: "nav-item",
                  on: {
                    click: function($event) {
                      _vm.setActive("typography")
                    }
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.isActive("typography") }
                    },
                    [_vm._v(_vm._s(_vm.$t("design.typography")))]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "nav-item",
                  on: {
                    click: function($event) {
                      _vm.setActive("colors")
                    }
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.isActive("colors") }
                    },
                    [_vm._v(_vm._s(_vm.$t("design.colors")))]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "nav-item",
                  on: {
                    click: function($event) {
                      _vm.setActive("forms")
                    }
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.isActive("forms") }
                    },
                    [_vm._v(_vm._s(_vm.$t("design.forms")))]
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-lg-10 pr-0" },
            [
              _vm.activeItem == "typography" ? _c("typography") : _vm._e(),
              _vm._v(" "),
              _vm.activeItem == "colors" ? _c("colors") : _vm._e(),
              _vm._v(" "),
              _vm.activeItem == "forms" ? _c("forms") : _vm._e()
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Styles/Index.vue?vue&type=template&id=b5285800&scoped=true&
// module id = null
// module chunks = 